export function formatTime(timeStr: string): string {
  if (!timeStr) return "";
  const isHm = /^\d{1,2}:\d{2}$/.test(timeStr);
  if (!isHm) return timeStr;
  const [h, m] = timeStr.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return timeStr;
  const period = h >= 12 ? "PM" : "AM";
  const displayH = h > 12 ? h - 12 : h === 0 ? 12 : h;
  return `${displayH}:${m.toString().padStart(2, "0")} ${period}`;
}
